import React, {Component} from "react";
import * as PropTypes from "prop-types";

export class EntryDescColorHoverLine extends Component {
	state = {hover: false};
	onMouseEnter = () => this.setState({hover: true});
	onMouseLeave = () => this.setState({hover: false});

	render = () => {
		let {children, entryDesc, onClick} = this.props;
		const {bgColor, textColor} = entryDesc.typeColor;
		let style;
		if (this.state.hover) {
			style = {
				background: bgColor,
				color: textColor,
			};
		}
		return (
			<div
				aria-label={entryDesc.label}
				style={style}
				onClick={onClick}
				onMouseEnter={this.onMouseEnter}
				onMouseLeave={this.onMouseLeave}
			>
				{children}
			</div>
		);
	}
}

EntryDescColorHoverLine.propTypes = {
	children: PropTypes.any,
	entryDesc: PropTypes.any,
	onClick: PropTypes.any
};
